const DOCUMENT_TYPES = {
  PDF: 'pdf',
  OFFICE: 'office',
  OTHER: 'other'
};

export default DOCUMENT_TYPES;
